import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import pb from '../lib/pocketbase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faClock, faImages, faMapMarkerAlt, faHistory, faCloudSun } from '@fortawesome/free-solid-svg-icons';
import styles from './ClientAccess.module.css';
// styles loaded via module

const ClientAccess = () => {
    const { id, token } = useParams();
    const [chantier, setChantier] = useState(null);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchChantier();
    }, [id, token]);

    const fetchChantier = async () => {
        try {
            // Verify access with token
            const record = await pb.collection('chantiers').getOne(id, {
                expand: 'client'
            });

            if (record.client_token !== token) {
                throw new Error("Accès non autorisé : Token invalide");
            }

            setChantier(record);

            // Fetch logs for this chantier
            const logRecords = await pb.collection('chantiers_photos').getList(1, 10, {
                filter: `chantier = "${id}"`,
                sort: '-created',
                expand: 'worker'
            });
            setLogs(logRecords.items);

            setLoading(false);
        } catch (err) {
            console.error(err);
            setError(err.message);
            setLoading(false);
        }
    };

    if (loading) return (
        <div className={styles.loaderContainer}>
            <div className={styles.spinner}></div>
            <p>Chargement de votre suivi de chantier...</p>
        </div>
    );

    if (error) return (
        <div className={styles.errorContainer}>
            <h2>Désolé</h2>
            <p>{error}</p>
            <button onClick={() => window.location.href = '/'}>Retour à l'accueil</button>
        </div>
    );

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <div className={styles.badge}>ESPACE CLIENT SÉCURISÉ</div>
                <h1>{chantier.name}</h1>
                <div className={styles.meta}>
                    <span><FontAwesomeIcon icon={faMapMarkerAlt} /> {chantier.address}</span>
                    <span className={styles.statusBadge} data-status={chantier.status}>
                        {chantier.status === 'TERMINE' ? 'Terminé' : 'En Cours'}
                    </span>
                </div>
            </header>

            <section className={styles.statsGrid}>
                <div className={styles.statCard}>
                    <div className={styles.statIcon}><FontAwesomeIcon icon={faCheckCircle} /></div>
                    <div className={styles.statLabel}>Progression</div>
                    <div className={styles.statValue}>{chantier.progress}%</div>
                    <div className={styles.progressTrack}>
                        <div className={styles.progressBar} style={{ width: `${chantier.progress}%` }}></div>
                    </div>
                </div>
                <div className={styles.statCard}>
                    <div className={styles.statIcon}><FontAwesomeIcon icon={faClock} /></div>
                    <div className={styles.statLabel}>Dernière mise à jour</div>
                    <div className={styles.statValue}>
                        {logs.length > 0 ? new Date(logs[0].created).toLocaleDateString('fr-FR') : '---'}
                    </div>
                </div>
            </section>

            <section className={styles.mainContent}>
                <div className={styles.journalSection}>
                    <h2><FontAwesomeIcon icon={faHistory} /> Journal d'avancement</h2>
                    <div className={styles.logList}>
                        {logs.map(log => (
                            <div key={log.id} className={styles.logCard}>
                                <div className={styles.logHeader}>
                                    <span className={styles.logDate}>{new Date(log.created).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                                    {log.weather && <span className={styles.weatherInfo}><FontAwesomeIcon icon={faCloudSun} /> {log.weather}</span>}
                                </div>
                                <p className={styles.logCaption}>{log.caption}</p>
                                {log.file && (
                                    <div className={styles.logGallery}>
                                        {(Array.isArray(log.file) ? log.file : [log.file]).map((f, i) => (
                                            <img key={i} src={pb.files.getURL(log, f)} alt="Prise de vue du jour" />
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.sidebar}>
                    <div className={styles.galleryPreview}>
                        <h3><FontAwesomeIcon icon={faImages} /> Photos Avant / Après</h3>
                        <div className={styles.comparisonGrid}>
                            {chantier.photos_before?.length > 0 && (
                                <div className={styles.photoBox}>
                                    <img src={pb.files.getURL(chantier, chantier.photos_before[0])} alt="Avant" />
                                    <span>AVANT</span>
                                </div>
                            )}
                            {chantier.photos_after?.length > 0 && (
                                <div className={styles.photoBox}>
                                    <img src={pb.files.getURL(chantier, chantier.photos_after[0])} alt="Après" />
                                    <span>APRÈS</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ClientAccess;
